module.exports = __webpack_public_path__ + "img/ic_photo_gallery.0388e8d3.svg";